import { FormField } from './form-field';

export class FormFieldCheckbox extends FormField<string> {
  controlType = 'checkbox';
  checked: boolean;
  defaultValue: boolean;

  constructor(options: {} = {}, defaultValue) {
    super(options);
    this.checked = defaultValue;
  }
}
